import angular from 'angular';

class NotificationService {
    displayNotificationInConfigurator(text) {
        let newNotification = angular.element('.configurator__info-box.--template').clone(true);
        newNotification.children('.configurator__info-box-text').text(text);
        newNotification.removeClass('--template');
        setTimeout(function() {
            newNotification.remove();
        }, 7500);

        angular.element('.configurator__info-box-wrapper').append(newNotification);
        this.removeOldestNotification();
    }

    removeOldestNotification() {
        let notifications = angular.element('.configurator__info-box:not(.--template)');

        if (notifications.length > 3) {
            notifications[0].remove();
        }
    }

    removeLatestNotification() {
        let notifications = angular.element('.configurator__info-box:not(.--template)');

        if (notifications.length > 0) {
            notifications[notifications.length - 1].remove();
        }
    }
}

export default angular.module('notificationService', [])
    .service('notificationService', NotificationService)
    .name;
